import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./send-sms.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./send-sms.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { APP_BASE_HREF } from "@angular/common";
import { AflaModuleStrategyService } from "../../services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../app-controller.service";
import { AlertType } from "../../models/alert";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import RecipientUtils from "../../utils/recipient-utils";
import { SendSmsConstants } from "./send-sms.constants";
import { SendSmsService } from "./service/send-sms.service";
import { Subject } from "rxjs";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { take, takeUntil } from "rxjs/operators";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PopUpComponent } from "../pop-up/pop-up.component";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { WorkflowJobService } from "../../services/workflow-job/workflow-job.service";
import { CurrentStepService } from "../../services/current-step/current-step.service";
let SendSmsComponent = class SendSmsComponent {
    baseHref;
    changeDetectionRef;
    sendSmsService;
    aflaModuleStrategyService;
    appController;
    workflowJobService;
    currentStepService;
    modalService;
    _destroy$ = new Subject();
    recipients;
    currentStepName;
    attachmentManagerAttachmentType;
    attachmentManagerTitle;
    attachmentManagerJobId;
    communicationType;
    linkToReplace;
    sendSmsButtonDisabled = false;
    infoLabel = "";
    currentLink;
    anonymousAccess = { anonymousDocumentAccess: false };
    smsSent = new EventEmitter();
    sendSmsForm;
    validationMessage = SendSmsConstants.VALIDATION_MESSAGES;
    smsTemplateLabel = SendSmsConstants.SMS_TEMPLATE_LABEL;
    selectedTemplateFromDropdown;
    smsTextLabel = SendSmsConstants.SMS_TEXT_LABEL;
    smsTextControl = SendSmsConstants.SMS_TEXT_CONTROL;
    sendSmsLabel = SendSmsConstants.SEND_SMS_LABEL;
    smsTemplates = [];
    commsType = SendSmsConstants.adHocComms;
    setSelectAttachmentRequired = false;
    componentName = SendSmsConstants.COMPONENT_NAME;
    application;
    currentUser;
    noRecipientErrMsg = SendSmsConstants.NO_RECIPIENT_ERR_MSG;
    smsSentMsg = SendSmsConstants.alertMessages.sendSmsSuccessful;
    invalidTemplateTypes = SendSmsConstants.invalidTemplateTypes;
    description;
    toSms = [];
    attachments = [];
    noCommunicationTypeErrMsg = SendSmsConstants.noCommunicationTypeErrMsg;
    noSmsTextErrMsg = SendSmsConstants.noSMSTextErrMsg;
    smsTextConstant = SendSmsConstants.smsTextConst;
    smsCommMechConst = SendSmsConstants.smsCommMechConst;
    smsCommDirectionConst = SendSmsConstants.smsCommDirectionConst;
    jobIdTextPlaceholder = SendSmsConstants.stringPlaceholders.jobId;
    selectedTextPlaceholder = SendSmsConstants.stringPlaceholders.selected;
    smsFieldTextPlaceholder = SendSmsConstants.stringPlaceholders.smsField;
    consolidatedGroupTextPlaceholder = SendSmsConstants.stringPlaceholders.consolidatedGroup;
    characters = "";
    getSmsTemplatesSubscription;
    logCommunicationSubscription;
    postSmsSubscription;
    portalUrl;
    constructor(baseHref, changeDetectionRef, sendSmsService, aflaModuleStrategyService, appController, workflowJobService, currentStepService, modalService) {
        this.baseHref = baseHref;
        this.changeDetectionRef = changeDetectionRef;
        this.sendSmsService = sendSmsService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.workflowJobService = workflowJobService;
        this.currentStepService = currentStepService;
        this.modalService = modalService;
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty("linkToReplace")) {
            this.linkToReplace = changes.linkToReplace.currentValue;
            this.onSelectTemplateChanged();
        }
    }
    ngOnInit() {
        this.loadPortalUrl();
        this.initForm();
        this.getSmsTemplates();
        this.getApplicantData();
    }
    onSelectTemplateChanged() {
        if (this.selectedTemplateFromDropdown !== undefined) {
            const smsBody = this.replaceKeyWords(this.selectedTemplateFromDropdown.template);
            this.sendSmsForm.get(this.smsTextControl).setValue(smsBody);
            this.updateCharacters();
        }
    }
    loadPortalUrl() {
        this.sendSmsService.getPortalUrl().subscribe(url => {
            this.portalUrl = url;
        });
    }
    sendSmsClicked() {
        this.description = "";
        this.setSmsReceiverAddresses();
        if (this.toSms.length === 0 ? true : false) {
            this.appController.showMessage(this.noRecipientErrMsg, AlertType.Warning);
            return;
        }
        if (this.communicationType === null || this.communicationType === undefined) {
            this.appController.showMessage(this.noCommunicationTypeErrMsg, AlertType.Warning);
            this.markFormControlsAsTouched();
            return;
        }
        if (this.sendSmsForm.get(this.smsTextControl).value === null ||
            this.sendSmsForm.get(this.smsTextControl).value === undefined) {
            this.appController.showMessage(this.noSmsTextErrMsg, AlertType.Warning);
            this.markFormControlsAsTouched();
            return;
        }
        const smsBody = this.getSmsText();
        if (smsBody.length > 160) {
            this.promptSmsLengthConfirmation(smsBody);
        }
        else {
            this.generateSms(smsBody);
            this.appController.showMessage(this.smsSentMsg, AlertType.Success);
        }
    }
    promptSmsLengthConfirmation(smsBody) {
        const messageLength = smsBody.length;
        const maxMessageLength = 160;
        const messageCount = Math.ceil(messageLength / maxMessageLength);
        const modalRef = this.modalService.open(PopUpComponent);
        modalRef.componentInstance.title = SendSmsConstants.CONFIRM_SMS_LENGTH_TITLE;
        modalRef.componentInstance.contentMessage = SendSmsConstants.CONFIRM_SMS_LENGTH_MESSAGE.replace('{messageCount}', messageCount.toString());
        modalRef.componentInstance.data = { smsBody, messageCount };
        modalRef.result.then((result) => {
            if (result) {
                this.generateSms(smsBody);
            }
        });
    }
    markFormControlsAsTouched() {
        Object.keys(this.sendSmsForm.controls).forEach((controlName) => {
            this.sendSmsForm.get(controlName).markAsTouched();
        });
        this.changeDetectionRef.detectChanges();
    }
    showInfoLabel() {
        return this.infoLabel !== "" ? true : false;
    }
    initForm() {
        this.sendSmsForm = new FormGroup({
            smsText: new FormControl(null, Validators.required)
        });
    }
    getSmsTemplates() {
        this.getSmsTemplatesSubscription = this.sendSmsService.getSmsTemplates(this.currentStepName, +this.appController.selectedModuleID).subscribe({
            next: (response) => {
                this.onGetSmsTemplatesCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Add);
            }
        });
    }
    onGetSmsTemplatesCompleted(response) {
        const templatesArray = response.value;
        templatesArray.forEach((template) => {
            if (template.type.toLowerCase() === this.smsTextConstant) {
                if (this.currentStepName === this.commsType) {
                    template.name = `${template.name} - ${template.stepName}`;
                    this.smsTemplates.push(template);
                }
                else if (template.stepName === this.currentStepName &&
                    (template.type.toLowerCase() === this.smsTextConstant)) {
                    this.smsTemplates.push(template);
                }
                this.smsTemplates.sort((a, b) => (a.name.localeCompare(b.name)));
            }
        });
        this.changeDetectionRef.detectChanges();
    }
    setupPortalApplicationUrl() {
        let applicationUrl = this.portalUrl;
        if (applicationUrl === undefined || applicationUrl === null || applicationUrl === "") {
            return "";
        }
        if (!applicationUrl.endsWith("/")) {
            applicationUrl += "/";
        }
        applicationUrl += +this.appController.selectedModuleID + "/viewapplication/" + this.attachmentManagerJobId + "/status";
        const applicationAHref = "<a class='text-underline-hover' href=\"" + applicationUrl + "\">" + applicationUrl + "</a>";
        return applicationAHref;
    }
    setupPortalUrl() {
        if (this.portalUrl === undefined || this.portalUrl === null || this.portalUrl === "") {
            return "";
        }
        const portalHref = "<a class='text-underline-hover' href=\"" + this.portalUrl + "\">" + this.portalUrl + "</a>";
        return portalHref;
    }
    replaceKeyWords(stringToBeReplace) {
        const appId = this.application.appId.toString();
        const userName = this.currentUser?.firstName;
        const userSurname = this.currentUser?.lastName;
        const userEmail = this.currentUser?.email;
        const linkToReplace = this.linkToReplace === undefined ? "Template has no link / Link has not been copied" : this.linkToReplace;
        const applicantEmail = this.application.applicant[0].email;
        const applicantName = this.application.applicant[0].name;
        const applicantTelephone = this.application.applicant[0].telephone;
        const applicantSurname = this.application.applicant[0].surname;
        const referenceNumber = this.application.referenceNumber;
        const aflaPortaApplicationlUrl = this.setupPortalApplicationUrl();
        const portalUrl = this.setupPortalUrl();
        let applicationUrl = window.location.origin;
        if (this.baseHref !== undefined && this.baseHref !== null && this.baseHref !== "") {
            applicationUrl += this.baseHref;
        }
        if (!applicationUrl.endsWith("/")) {
            applicationUrl += "/";
        }
        applicationUrl += +this.appController.selectedModuleID + "/viewapplication/" + this.attachmentManagerJobId + "/content/details";
        const applicationAHref = "<a class='text-underline-hover' href=\"" + applicationUrl + "\">" + applicationUrl + "</a>";
        let requestCommentUrl = window.location.origin;
        if (this.baseHref !== undefined && this.baseHref !== null && this.baseHref !== "") {
            requestCommentUrl += this.baseHref;
        }
        if (!requestCommentUrl.endsWith("/")) {
            requestCommentUrl += "/";
        }
        requestCommentUrl += +this.appController.selectedModuleID + "/viewapplication/" + this.attachmentManagerJobId + "/content/details";
        const requestCommentAHref = "<a class='text-underline-hover' href=\"" + requestCommentUrl + "\">" + requestCommentUrl + "</a>";
        const replacedText = stringToBeReplace.replace(/{AppId}|{ApplicantName}|{ApplicantPhoneNo}|{ApplicantSurname}|{RefNo}|{ReferenceNumber}|{UserName}|{UserSurname}|{UserSms}|{UserPhoneNo}|{ApplicantSms}|{LINK_TO_SURVEY_URL}|{LINK_TO_APPLICATION_URL}|{LINK_TO_REQUEST_COMMENT_URL}|{CurrentDate}|{LinkToPortalUrl}|{LinkToPortalApplicationUrl}/gi, function x(searchWord) {
            let result = "";
            switch (searchWord) {
                case "{AppId}":
                    result = appId;
                    return result;
                case "{ApplicantEmail}":
                    result = applicantEmail;
                    return result;
                case "{ApplicantName}":
                    result = applicantName;
                    return result;
                case "{ApplicantPhoneNo}":
                    result = applicantTelephone;
                    return result;
                case "{ApplicantSurname}":
                    result = applicantSurname;
                    return result;
                case "{RefNo}":
                    result = referenceNumber;
                    return result;
                case "{ReferenceNumber}":
                    result = referenceNumber;
                    return result;
                case "{UserName}":
                    result = userName;
                    return result;
                case "{UserSurname}":
                    result = userSurname;
                    return result;
                case "{UserEmail}":
                    result = userEmail;
                    return result;
                case "{UserPhoneNo}":
                    result = "N/A";
                    return result;
                case "{LINK_TO_SURVEY_URL}":
                    result = linkToReplace;
                    return result;
                case "{LINK_TO_APPLICATION_URL}":
                    result = applicationAHref;
                    return result;
                case "{LINK_TO_REQUEST_COMMENT_URL}":
                    result = requestCommentAHref;
                    return result;
                case "{CurrentDate}":
                    {
                        const datePipe = new SaShortDatePipe('en-ZA');
                        result = datePipe.transform(new Date());
                    }
                case "{LinkToPortalUrl}":
                    result = portalUrl;
                    return result;
                case "{LinkToPortalApplicationUrl}":
                    result = aflaPortaApplicationlUrl;
                    return result;
            }
        });
        return replacedText;
    }
    logSmsCommunication(updateRecipients) {
        let recipientsToUpdate;
        if (updateRecipients) {
            recipientsToUpdate = this.removeUnwantedProperties();
        }
        const communicationId = null;
        const commmunication = {
            communicationType: this.communicationType,
            jobId: +this.attachmentManagerJobId,
            communicationMechanism: this.smsCommMechConst,
            direction: this.smsCommDirectionConst,
            relatedCommunicationId: communicationId,
            description: this.description,
            recipients: recipientsToUpdate,
            attachments: this.attachments,
            deleted: false
        };
        const step = this.currentStepService.currentStep;
        this.logCommunicationSubscription =
            this.sendSmsService.logCommunication(commmunication, this.appController.selectedJobID, step.name, step.id)
                .subscribe({
                next: () => {
                    this.sendSmsForm.reset();
                    this.selectedTemplateFromDropdown = undefined;
                    this.smsSent.emit(true);
                },
                error: (error) => {
                    this.appController.showMessage(SendSmsConstants.ERROR_LOGGING_SMS, AlertType.Error);
                }
            });
    }
    setSmsReceiverAddresses() {
        if (this.recipients) {
            this.toSms = [];
            this.recipients.forEach((recipient) => {
                if (recipient.hasOwnProperty(this.smsFieldTextPlaceholder)) {
                    if (this.toSms.indexOf(recipient.cellphone) === -1) {
                        this.toSms.push(recipient.cellphone);
                    }
                    this.description += "To " + this.toSms + " " + "\r\n";
                }
                else {
                    this.description += "To " + this.toSms + " " + "\r\n";
                }
            });
        }
    }
    getSmsText() {
        const smsBody = this.sendSmsForm.get(this.smsTextControl).value;
        this.description += "Body: " + smsBody + "\r\n";
        return smsBody;
    }
    generateSms(smsBody) {
        const params = {
            moduleId: +this.appController.selectedModuleID,
            numbers: this.toSms,
            message: smsBody
        };
        this.postSmsSubscription = this.sendSmsService.postSms(params).subscribe({
            next: () => {
                this.appController.showMessage(this.smsSentMsg, AlertType.Success);
                this.logSmsCommunication(true);
            },
            error: (error) => {
                this.appController.showMessage(SendSmsConstants.ERROR_SENDING_SMS, AlertType.Error);
            }
        });
    }
    removeUnwantedProperties() {
        const recipientsToUpdate = this.recipients;
        recipientsToUpdate.forEach((recipient) => {
            recipient = RecipientUtils.removeRecipientProperties(recipient);
        });
        return recipientsToUpdate;
    }
    getApplicantData() {
        const params = {
            $filter: `jobId eq ${this.attachmentManagerJobId} and moduleId eq ${+this.appController.selectedModuleID}`,
            $expand: this.aflaModuleStrategyService.getSelectedApplicationSummaryExpand()
        };
        this.aflaModuleStrategyService.getApplicationsQuery(params).pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (returnValue) => {
                this.application = returnValue.value[0];
            },
            error: (error) => {
                this.appController.handleServerErrorMessage("send-sms", error, CRUDOperation.Get);
            }
        });
    }
    updateCharacters() {
        const message = this.sendSmsForm.get("smsText").value;
        const count = message.length;
        const messageCount = Math.ceil(count / 160);
        this.characters = count + "/" + messageCount;
    }
    static ctorParameters = () => [
        { type: String, decorators: [{ type: Inject, args: [APP_BASE_HREF,] }] },
        { type: ChangeDetectorRef },
        { type: SendSmsService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: WorkflowJobService },
        { type: CurrentStepService },
        { type: NgbModal }
    ];
    static propDecorators = {
        recipients: [{ type: Input }],
        currentStepName: [{ type: Input }],
        attachmentManagerAttachmentType: [{ type: Input }],
        attachmentManagerTitle: [{ type: Input }],
        attachmentManagerJobId: [{ type: Input }],
        communicationType: [{ type: Input }],
        linkToReplace: [{ type: Input }],
        sendSmsButtonDisabled: [{ type: Input }],
        infoLabel: [{ type: Input }],
        currentLink: [{ type: Input }],
        anonymousAccess: [{ type: Input }],
        smsSent: [{ type: Output }]
    };
};
SendSmsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-send-sms",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], SendSmsComponent);
export { SendSmsComponent };
